module.exports = __webpack_public_path__ + "img/box2_icon3.9c41b4f1.png";